// extracted by mini-css-extract-plugin
module.exports = {"audit":"Audit_audit__ctdHv","audit__listSide":"Audit_audit__listSide__1m7TO","audit__tableSide":"Audit_audit__tableSide__3kATA","sticky":"Audit_sticky__1ApvW"};